export default "__VITE_ASSET__22818ec2__"